var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-room" },
    [
      _c("modal-background"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chat-room--content" },
        [
          _c("modal-close-button", {
            staticClass: "chat-room--close-button",
            on: { click: _vm.onCloseButtonClick }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chat-room--header" },
            [
              _vm.chatRoom
                ? _c("chat-member", {
                    staticClass: "chat-room--member",
                    attrs: {
                      "current-user": _vm.currentUser,
                      member: _vm.chatRoom
                        ? _vm.chatRoomMember
                        : _vm.defaultMember,
                      relationship: _vm.chatRoom
                        ? _vm.chatRoom.relationship
                        : _vm.defaultMember.relationship,
                      communityImage: _vm.chatRoom.image
                        ? _vm.chatRoom.image
                        : null,
                      communityTitle: _vm.chatRoom.title
                        ? _vm.chatRoom.title
                        : null
                    },
                    on: { "open-community-detail": _vm.openCommunityDetail }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "minimized-chat-room--close-button",
                  attrs: { type: "button" },
                  on: { click: _vm.onCloseButtonClick }
                },
                [
                  _c("img", {
                    staticClass: "minimized-chat-room--close-icon",
                    attrs: { src: _vm.closeButtonIcon, alt: "閉じる" }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "chatRoomBody",
              staticClass: "chat-room--body",
              on: { scroll: _vm.onScroll }
            },
            [
              _vm.chatRoom
                ? _c("div", [
                    _vm.showLineNotifyStatus()
                      ? _c(
                          "div",
                          { staticClass: "chat-room-line-notification" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "chat-room-line-choice" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "line-choice-auth",
                                    on: {
                                      click: function($event) {
                                        return _vm.lineAuthButtonClick(
                                          _vm.chatRoom
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("\n              はい\n            ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "line-choice-close",
                                    on: { click: _vm.lineCloseButtonClick }
                                  },
                                  [
                                    _vm._v(
                                      "\n              いいえ\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "line-choice-never-see",
                                    on: { click: _vm.lineNeverSeeButtonClick }
                                  },
                                  [
                                    _vm._v(
                                      "\n              いいえ、今後表示しない\n            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chat-room--messages" },
                [
                  !_vm.chatRoom
                    ? _c("div", { style: { "text-align": "center" } }, [
                        _vm._v("\n          ロード中...\n        ")
                      ])
                    : _vm._l(_vm.chatRoomMessages, function(msg, index) {
                        return _c(
                          "div",
                          {
                            key: msg.id,
                            staticClass: "chat-container",
                            on: {
                              mouseover: function($event) {
                                _vm.hoveredMessageId = msg.id
                              },
                              mouseleave: function($event) {
                                _vm.reactToMessageId = null
                              }
                            }
                          },
                          [
                            !msg.from &&
                            _vm.isFirstMessage(msg, index) &&
                            msg.member_id != _vm.currentUser.mother_id &&
                            msg.member_id
                              ? _c("div", { staticClass: "user-container" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "member-icon chat-member--icon small"
                                    },
                                    [
                                      msg.to ||
                                      msg.member_id != _vm.currentUser.mother_id
                                        ? _c("img", {
                                            ref: "image" + msg.id,
                                            refInFor: true,
                                            staticClass: "member-icon--image",
                                            attrs: {
                                              src: _vm.chatRoom
                                                ? _vm.getMemberImage(
                                                    msg.member_id,
                                                    msg.id
                                                  )
                                                : _vm.defaultMember.avatar_path,
                                              alt: _vm.chatRoom
                                                ? _vm.getMemberName(
                                                    msg.member_id
                                                  )
                                                : _vm.defaultMember.firstName
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.chatRoom.title
                                    ? _c(
                                        "span",
                                        { staticClass: "chat-member--name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.chatRoom
                                                ? _vm.getMemberName(
                                                    msg.member_id
                                                  )
                                                : _vm.defaultMember.firstName
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "chat-member--name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.chatRoom
                                                ? _vm.chatRoom.member.firstName
                                                : _vm.defaultMember.firstName
                                            )
                                          )
                                        ]
                                      )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            msg.ref && msg.ref.type === "reply"
                              ? _c("div", { staticClass: "replied-message" }, [
                                  _c("span", { style: { fontSize: "80%" } }, [
                                    msg.ref.message.member_id ===
                                    _vm.currentUser.mother_id
                                      ? _c("span", [
                                          _c("strong", [_vm._v("自分")]),
                                          _vm._v("：\n              ")
                                        ])
                                      : _c("span", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                msg.ref.message.member_name
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            "\n                さん：\n              "
                                          )
                                        ])
                                  ]),
                                  _vm._v(" "),
                                  _c("hr", { style: { margin: "0.25rem 0" } }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(msg.ref.message.body)
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "chat-message",
                                class: [
                                  msg.member_id
                                    ? {
                                        "from-me":
                                          msg.member_id ===
                                          _vm.currentUser.mother_id,
                                        "to-me":
                                          msg.member_id !=
                                          _vm.currentUser.mother_id,
                                        "is-file":
                                          msg.files && msg.files.length > 0
                                      }
                                    : {
                                        "from-me": msg.from,
                                        "to-me": msg.to,
                                        "is-file":
                                          msg.file_array &&
                                          msg.file_array.length > 0
                                      }
                                ]
                              },
                              [
                                _c("span", {
                                  style: { width: "100%" },
                                  domProps: { innerHTML: _vm._s(msg.body) }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "message-reactions" },
                                  _vm._l(msg.reactions, function(r, i) {
                                    return _c(
                                      "span",
                                      { key: i },
                                      [
                                        _c("fa", {
                                          style: {
                                            color: _vm.getReactionColor(r)
                                          },
                                          attrs: {
                                            icon: r.package
                                              ? [r.package, r.icon]
                                              : r.icon
                                          }
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(r.count > 1 ? r.count : "") +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "time-stamp additional-info" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              msg.id === _vm.hoveredMessageId,
                                            expression:
                                              "msg.id === hoveredMessageId"
                                          }
                                        ],
                                        staticClass: "btn-group"
                                      },
                                      [
                                        _c("fa", {
                                          staticClass: "btn-icon",
                                          attrs: { icon: ["far", "smile"] },
                                          on: {
                                            click: function($event) {
                                              _vm.reactToMessageId = _vm.reactToMessageId
                                                ? null
                                                : msg.id
                                              _vm.hoveredMessageId = null
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("fa", {
                                          staticClass: "btn-icon",
                                          attrs: { icon: "reply" },
                                          on: {
                                            click: function($event) {
                                              _vm.replyToMessageId = msg.id
                                              _vm.hoveredMessageId = null
                                              _vm.chatBodyChange(2)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("moment")(
                                              new Date(msg.timestamp),
                                              _vm.isToday(msg.timestamp)
                                                ? "HH:mm"
                                                : "YYYY/MM/DD HH:mm"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  msg.file_array ? msg.file_array : msg.files,
                                  function(file) {
                                    return _c(
                                      "div",
                                      {
                                        key: file.id,
                                        class: {
                                          "chat-item chat-room-filelist":
                                            file.name != "recording.wav",
                                          "chat-item chat-room-audiofile":
                                            file.name == "recording.wav"
                                        }
                                      },
                                      [
                                        (msg.member_id ===
                                          _vm.currentUser.mother_id &&
                                          file.name != "recording.wav") ||
                                        (msg.from &&
                                          file.name != "recording.wav")
                                          ? _c("img", {
                                              staticClass:
                                                "chat-room-download-icon",
                                              attrs: {
                                                src: _vm.downloadIcon,
                                                alt: "Download"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadFile(
                                                    file.path,
                                                    file.name
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "chat-room-image" },
                                          [
                                            file.name == "captured-video.mp4"
                                              ? _c("video", {
                                                  staticClass: "video",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "border-radius": "15px"
                                                  },
                                                  attrs: {
                                                    id: msg.id,
                                                    preload: "none",
                                                    type: "video/mp4",
                                                    src: file.path,
                                                    width: "100%",
                                                    controls: "",
                                                    disablePictureInPicture: "",
                                                    controlslist: "nodownload"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            file.name == "recording.wav"
                                              ? _c("audio", {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "margin-left": "0px"
                                                  },
                                                  attrs: {
                                                    id: msg.id,
                                                    preload: "none",
                                                    type: "audio/x-wav",
                                                    src: file.path,
                                                    controls: "",
                                                    controlslist: "nodownload"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isImage(file)
                                              ? _c("img", {
                                                  staticClass:
                                                    "chat-room-img-file",
                                                  attrs: {
                                                    src: file.path,
                                                    alt: "",
                                                    loading: "lazy"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onFileClick(
                                                        file.path
                                                      )
                                                    }
                                                  }
                                                })
                                              : file.name != "recording.wav" &&
                                                file.name !=
                                                  "captured-video.mp4"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-room-not-img-file"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.getExe(file.name)
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            file.name != "recording.wav" &&
                                            file.name != "captured-video.mp4"
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.shortFileName(
                                                          file.name,
                                                          22
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        msg.to && file.name != "recording.wav"
                                          ? _c("img", {
                                              staticClass:
                                                "chat-room-download-icon",
                                              attrs: {
                                                src: _vm.downloadIcon,
                                                alt: "Download"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadFile(
                                                    file.path,
                                                    file.name
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        msg.member_id &&
                                        msg.member_id !=
                                          _vm.currentUser.mother_id &&
                                        file.name != "recording.wav"
                                          ? _c("img", {
                                              staticClass:
                                                "chat-room-download-icon",
                                              attrs: {
                                                src: _vm.downloadIcon,
                                                alt: "Download"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadFile(
                                                    file.path,
                                                    file.name
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.reactToMessageId === msg.id,
                                    expression: "reactToMessageId === msg.id"
                                  }
                                ],
                                staticClass: "reaction-buttons btn-group"
                              },
                              _vm._l(_vm.reactions, function(r, i) {
                                return _c(
                                  "span",
                                  {
                                    key: i,
                                    style: { position: "relative" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addReaction(msg, r)
                                      }
                                    }
                                  },
                                  [
                                    _c("fa", {
                                      staticClass: "btn-icon",
                                      style: {
                                        color: r.color,
                                        background: "transparent"
                                      },
                                      attrs: {
                                        icon: r.package
                                          ? [r.package, r.icon]
                                          : r.icon
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isReactionCreatedByMe(
                                              msg,
                                              r
                                            ),
                                            expression:
                                              "isReactionCreatedByMe(msg, r)"
                                          }
                                        ],
                                        style: {
                                          position: "absolute",
                                          left: "3px",
                                          top: "50%",
                                          fontSize: "medium"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                ・\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          ]
                        )
                      })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chat-room--footer" },
            [
              _vm.isShowArrow
                ? _c("div", { staticClass: "scroll-arrow" }, [
                    _c("img", {
                      staticClass: "chat-room-scroll-arrow",
                      attrs: { src: _vm.arrowIcon, alt: "scroll" },
                      on: {
                        click: function($event) {
                          return _vm.scrollToLastMessage()
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("message-input", {
                attrs: {
                  disabled: !_vm.chatRoom,
                  message: _vm.message,
                  followings: _vm.followings.filter(function(following) {
                    return following.followee != undefined
                  }),
                  chatRoomMembers: _vm.chatRoomMembers,
                  fileList: _vm.fileList,
                  mentions: _vm.mentions,
                  "video-limit": _vm.videoLimit,
                  "ref-message": _vm.refMessage,
                  chatLoading: _vm.chatLoading
                },
                on: {
                  "update:message": function($event) {
                    _vm.message = $event
                  },
                  "update:fileList": function($event) {
                    _vm.fileList = $event
                  },
                  "update:file-list": function($event) {
                    _vm.fileList = $event
                  },
                  "update:mentions": function($event) {
                    _vm.mentions = $event
                  },
                  "upload-file-set": function($event) {
                    return _vm.chatBodyChange(1)
                  },
                  "upload-file-remove": function($event) {
                    return _vm.chatBodyChange(0)
                  },
                  "reply-set": function($event) {
                    return _vm.chatBodyChange(2)
                  },
                  "send-button-click": _vm.raiseSendEvent,
                  "clear-ref-message": function($event) {
                    _vm.replyToMessageId = null
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.modalPreviewShow
        ? _c("modal-image", {
            attrs: { uploadImage: _vm.modalImageFilePath },
            on: { "close-button-click": _vm.closeModalImage }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chat-room-line-title" }, [
      _c("img", {
        attrs: {
          src:
            "https://eys-file.s3-ap-northeast-1.amazonaws.com/gate/image/icon/line-icon.svg",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("新しいメッセージをLINE通知で受け取りますか。")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }